import moment from 'src/app/utils/moment-timezone';

export class  CalendarSession {
  lastModifiedDate?: string;
  lastModifiedBy?: string;
  id: string;
  creationDate: string;
  createdBy: string;
  title: string;
  description: string;
  color?: string;
  isPublic: boolean;
  duration: number;
  publicPortal: boolean;
  status: "active" | "archived";

  constructor (init: Partial<CalendarSession>){
      Object.assign(this, init);
  }
}